import {Service} from '@/request/http.js'

// 获取用户信息
export function getHotelList (data) {
  return Service({
    url: '/api/search',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/search.js